<template>
  <div>
    <!-- RELÓGIO -->
    <div>
      <div class="d-flex justify-center pt-4">
        <div class="justify-center align-center overline">
          <div class="d-flex align-center grey--text">
            {{ time }} &nbsp; {{ $gmt() }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex align-center text-center overline mb-10 mt-2"
      style="color: rgba(255, 255, 255, 0.5); font-size: 12px"
      :class="[
        $vuetify.breakpoint.smAndDown ? 'flex-column' : 'justify-center',
      ]"
    >
      <!-- <div>{{ $gmt() }} &nbsp;</div> -->
      <div>{{ $t("playResponsibly") }} &nbsp;</div>
      <div>{{ $t("prohibitedForUnder18") }} &nbsp;</div>
      <div>
        <v-avatar color="grey darken-3" size="36">
          <span class="white--text subtitle-2">18+</span>
        </v-avatar>
      </div>
    </div>

    <!-- PARCEIROS E PATROCÍNIOS -->
    <div v-if="logos.length > 0">
      <div class="d-flex overline justify-start align-center px-3">
        <v-divider class="mr-4"></v-divider>
        <div class="pl-2 grey--text" style="font-size: 10px">
          {{ $t("partnersAndSponsorships") }}
        </div>
        <v-divider class="ml-4"></v-divider>
      </div>
      <div class="d-flex justify-center flex-wrap pt-4">
        <div
          class="justify-center align-center"
          v-for="(logo, i) in logos"
          :key="`logo-${i}`"
        >
          <div style="height: 120px" class="d-flex align-center">
            <a
              :href="logo.url"
              :style="logo.url ? 'cursor:pointer' : 'cursor:auto'"
              target="_blank"
            >
              <v-img
                class="ma-2"
                max-height="100"
                max-width="100"
                :src="logo.urlImg"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- / PARCEIROS E PATROCÍNIOS -->

    <!-- MEIOS DE PAGAMENTO -->
    <div v-if="paymentMethods.length > 0" class="mt-6">
      <div class="d-flex overline justify-start align-center px-3">
        <v-divider class="mr-4"></v-divider>
        <div class="pl-2 grey--text" style="font-size: 10px">
          {{ $t("paymentMethods") }}
        </div>
        <v-divider class="ml-4"></v-divider>
      </div>
      <div class="d-flex justify-center flex-wrap pt-4">
        <div
          class="justify-center align-center"
          v-for="(payment, i) in paymentMethods"
          :key="`payment-${i}`"
        >
          <div style="height: 80px" class="d-flex align-center">
            <a
              :href="payment.url"
              :style="payment.url ? 'cursor:pointer' : 'cursor:auto'"
              target="_blank"
            >
              <v-img
                class="ma-2"
                max-height="100"
                max-width="100"
                :src="payment.urlImg"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- / MEIOS DE PAGAMENTO -->

    <v-divider class="my-5"></v-divider>
    <v-row no-gutters class="mb-6">
      <v-col cols="12" sm="12" md="3" class="text-center mt-6">
        <div
          class="d-flex align-center text-center justify-center fill-height flex-grow-1"
        >
          <img
            :style="{
              'max-width': $vuetify.breakpoint.smAndDown ? '170px' : '170px',
              'max-height': '120px',
            }"
            class="cursor-pointer mb-6"
            v-on:click="toRoute('home')"
            aspect-ratio="1.0"
            :src="src"
            :alt="domain"
          />
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-row no-gutters>
          <v-col
            cols="12"
            md="6"
            class="py-2 justify-center align-center d-flex flex-column"
            v-for="(links, i) in [
              iCompany,
              iDownloads,
              iRules,
              iResponsibleGaming,
            ]"
            :key="i"
          >
            <div class v-for="(link, l) in links" :key="l">
              <v-btn
                v-if="!link.blankUrl"
                text
                v-show="link.meta.show"
                block
                class="mb-1 py-4"
                x-small
                :to="{
                  name: link.name,
                  query: link.query,
                  hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
                }"
                >{{ link.nameFooter }}</v-btn
              >
              <v-btn
                v-else
                text
                v-show="link.meta.show"
                block
                class="mb-1 py-4"
                x-small
                :href="link.blankUrl"
                target="_blank"
              >
                {{ link.nameFooter }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- <v-col
        cols="12"
        sm="4"
        md="2"
        class="py-2 justify-center align-center d-flex flex-column"
        v-for="(links, i) in [iResponsibleGaming]"
        :key="`iResponsibleGaming-${i}`"
      >
        <div class v-for="(link, l) in links" :key="l">
          <v-btn
            text
            v-show="link.meta.show"
            block
            class="mb-1 py-4"
            x-small
            :to="{
              name: link.name,
              query: link.query,
              hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
            }"
            >{{ link.nameFooter }}</v-btn
          >
        </div>
      </v-col> -->

      <v-col cols="12" sm="12" md="3" class="grey--text text-center">
        <div
          class="d-flex align-center text-center justify-center fill-height flex-grow-1"
        >
          <div
            v-for="(item, i) in social"
            :key="`social-${i}`"
            class="d-inline-flex mx-2"
          >
            <v-btn block icon :href="getItemUrl(item)" :disabled="!item.social">
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-divider class="my-5"></v-divider>

    <div
      class="d-flex align-center justify-center"
      :class="{
        'flex-column-reverse': $vuetify.breakpoint.mobile,
      }"
      style="gap: 30px"
    >
      <div v-if="$domain() === 'cartola'">
        <div
          id="apg-bf9ef0d1-f4fb-497d-929b-c7d9c6afea38"
          data-apg-seal-id="bf9ef0d1-f4fb-497d-929b-c7d9c6afea38"
          data-apg-image-size="60"
          data-apg-image-type="basic-light-large"
        ></div>
      </div>

      <AnjLicense v-if="operatorsDomainWithAnjLicense.includes($domain())" />

      <div v-else-if="$permissions().license">
        <div
          class="caption px-4 pt-2 text-justify"
          style="
            color: rgba(255, 255, 255, 0.5);
            max-width: 960px;
            margin: 0 auto;
          "
        >
          <span v-html="$permissions().license"></span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-center pt-4">
      <div
        class="justify-center align-center"
        v-for="(logo, i) in logosLicenses"
        :key="`logo-${i}`"
      >
        <div style="height: 70px" class="d-flex align-center">
          <a
            :href="logo.url"
            :style="logo.url ? 'cursor:pointer' : 'cursor:auto'"
            target="_blank"
          >
            <v-img
              class="ma-2"
              max-height="110"
              max-width="110"
              :src="logo.urlImg"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </a>
        </div>
      </div>
      <div
        v-if="gcbLicense"
        class="justify-center align-center d-flex flex-column"
      >
        <a
          class="justify-center align-center d-flex flex-column"
          target="_blank"
          rel="noopener"
          :href="gcbLicense"
        >
          <img
            width="56"
            height="42"
            decoding="async"
            data-nimg="1"
            style="max-width:100%;height:auto"
            src="./gcb.jpg"
            loading="lazy"
          />
          <span class="mt-2" style="font-size: 0.9em;">Licença de jogo</span>
        </a>
      </div>
    </div>
    <v-divider class="mt-4"></v-divider>
    <!-- COPYRIGHT - VERSION - POWERED BY -->
    <div
      class="d-flex mb-4"
      :class="[
        $vuetify.breakpoint.smAndDown ? 'flex-column' : 'justify-space-between',
      ]"
    >
      <div
        class="my-6 text-center pl-4"
        style="color: rgba(255, 255, 255, 0.5); font-size: 12px"
      >
        <span style="font-size: 12px !important">
          {{ new Date().getFullYear() }} ©
          {{ $store.state.operators.operator_name }}.
          {{ $t("allRightsReserved") }}
        </span>
      </div>

      <div
        class="d-flex align-center justify-center grey--text pr-4"
        :class="[
          $vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center',
        ]"
        style="font-size: 12px !important"
      >
        <div>Platform Version {{ $store.state.appVersionVuex }}</div>
        <template
          v-if="
            operatorsDomainWithAnjLicense.includes($domain()) ||
              $permissions().poweredBySga
          "
        >
          <a href="https://sga.bet" target="_blank" class="ml-2">
            <img
              width="80"
              src="../../assets/logo_sga.png"
              alt="Sga.bet"
              title="Sga.bet"
          /></a>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {
  company,
  downloads,
  rules,
  responsibleGaming,
} from "@/views/pages/routers.js";
import axios from "axios";
import AnjLicense from "./AnjLicense";

const headers = {
  "Content-Type": "application/json",
};

const baseUrlS3 = "https://dozr8la71aog.cloudfront.net/";
export default {
  name: "footer_inst",
  data: () => ({
    iCompany: company,
    iDownloads: downloads,
    iRules: rules,
    iResponsibleGaming: responsibleGaming,
    domain: "",
    logos: [],
    logosLicenses: [],
    paymentMethods: [],
    time: null,
    src: "",
    operatorsDomainWithAnjLicense: [
      "a3bet",
      "aki",
      "amabet",
      "jogodeourobet",
      // "pagamaissports",
      "pingolbet",
      // "sullbet",
    ],
  }),
  components: {
    AnjLicense,
  },
  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval);
  },
  async created() {
    this.serveTime = this.getServerTime(); // update the time every second
  },
  async mounted() {
    this.domain = this.$domain();
    this.listImgsPartners();

    // IF - Permissions
    if (this.$permissions().license) {
      this.listImgsLicenses();
    }

    this.nameFooters();
    this.listImgsPaymentMethods();

    // logo footer custom
    switch (this.domain) {
      case "bellosports":
      case "betina123":
      case "betsprime":
      case "sonhobet":
      case "sonhobetcom":
      case "apostador":
      case "panibet":
      case "viapix":
      case "pokarbet":
        this.src = `https://dozr8la71aog.cloudfront.net/domains/${this.domain}/img/logo_footer.png`;
        break;
      default:
        this.src = this.$operatorLogoUrl(this.domain);
        break;
    }
  },
  computed: {
    social() {
      return this.$store.getters.getOperatorSocial;
    },
    baseUrlApiGateway() {
      return this.$lambdaUrl();
    },
    gcbLicense() {
      if (this.$domain() === "podersports") {
        return "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbWxRTUdaQ1dsZERZWFZ6TjJaVlowVlRTa2RoSzNjOVBTSXNJblpoYkhWbElqb2lUUzlsYm04dmVIQm1ia0Y0VFU4eU9WQkRNRUpJVVQwOUlpd2liV0ZqSWpvaU5UQTVNV0UxTkdNM09XSTFaalV5TVRFeU9ETXpOVFUzT0RVek5qSXpNVEJsWVRjeE0yUm1ORGt3TkRJNE9HWTBOVEEwWlRoak5qQmlZek01WkdSaU1TSXNJblJoWnlJNklpSjk=";
      }

      return false;
    },
  },
  methods: {
    // Logos Parceiros e Patrocínios
    async listImgsPartners() {
      const { isExpired, data } = await this.$localbase.get({
        type: "partnersImages",
      });

      if (!isExpired && data) {
        this.logos = data;
        this.loading = false;
        return;
      }

      const url = `${this.baseUrlApiGateway}/s3/listImgsPartners`;
      axios
        .post(`${url}`, { domain: this.domain }, { headers: headers })
        .then((resp) => {
          const contents = resp.data;

          contents.forEach((item) => {
            if (item.Size > 0) {
              let urlImg = baseUrlS3 + encodeURIComponent(item.Key);
              let url = this.$constructURL(item.Key);
              this.logos.push({ urlImg, url });
            }
          });

          this.$localbase.set({ type: "partnersImages", data: this.logos });
        })
        .catch(() => {
          const msg = this.$t("noLoadPartner");
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        });
    },

    // Logos Licenças
    async listImgsLicenses() {
      const { isExpired, data } = await this.$localbase.get({
        type: "licenses",
      });

      if (!isExpired && data) {
        this.logosLicenses = data;
        return;
      }

      const url = `${this.baseUrlApiGateway}/s3/listImgsLicenses`;
      axios
        .post(`${url}`, { domain: this.domain }, { headers: headers })
        .then((resp) => {
          const contents = resp.data;
          contents.forEach((item) => {
            if (item.Size > 0) {
              let urlImg = baseUrlS3 + encodeURIComponent(item.Key);
              let url = this.$constructURL(item.Key);
              if (!url) {
                if (urlImg.includes("BeGambleAware")) {
                  url = "https://www.gambleaware.org/home";
                } else if (urlImg.includes("LogoGt")) {
                  url = "https://www.gamblingtherapy.org/pt-br/";
                }
              }
              this.logosLicenses.push({ urlImg, url });
            }
          });

          this.$localbase.set({ type: "licenses", data: this.logosLicenses });
        })
        .catch(() => {
          const msg = this.$t("noLoadLicenses");
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        });
    },

    // Logos Licenças
    async listImgsPaymentMethods() {
      const { isExpired, data } = await this.$localbase.get({
        type: "paymentMethods",
      });

      if (!isExpired && data) {
        this.paymentMethods = data;
        return;
      }

      const url = `${this.baseUrlApiGateway}/s3/listImgsPaymentMethods`;
      axios
        .post(`${url}`, { domain: this.domain }, { headers: headers })
        .then((resp) => {
          const contents = resp.data;
          contents.forEach((item) => {
            if (item.Size > 0) {
              let urlImg = baseUrlS3 + encodeURIComponent(item.Key);
              let url = this.$constructURL(item.Key);
              this.paymentMethods.push({ urlImg, url });
            }
          });

          this.$localbase.set({
            type: "paymentMethods",
            data: this.paymentMethods,
          });
        })
        .catch(() => {
          const msg = this.$t("noLoadPaymentMethods");
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        });
    },

    toRoute: function(page) {
      if (page === "home") {
        this.$router.push({
          name: this.$permissions().bigTable ? "bigTable" : "Sports",
          query: {
            sport: "Futebol",
            live: "Futebol",
          },
        });
      }
    },
    nameFooters() {
      let translateName = {
        about: this.$t("about"),
        carres: this.$t("carres"),
        contact: this.$t("contact"),
        appClient: this.$t("appClient"),
        appAgent: this.$t("appAgent"),
        help: this.$t("help"),
        regulation: this.$t("regulation"),
        terms: this.$t("terms"),
        responsibleGaming: this.$t("responsibleGaming"),
        privacy: this.$t("privacy"),
        accountSuspend: this.$t("accountSuspend"),
        autoExclude: this.$t("autoExclude"),
        amlPolicy: this.$t("amlPolicy"),
        blog: "Blog",
        affiliates: this.$t("affiliates"),
        askedQuestions: this.$t("frequentlyAskedQuestions"),
      };
      this.iCompany.forEach((company) => {
        company.nameFooter = translateName[company.path];
      });
      this.iDownloads.forEach((downloads) => {
        downloads.nameFooter = translateName[downloads.path];
      });
      this.iRules.forEach((rules) => {
        rules.nameFooter = translateName[rules.path];
      });
      this.iResponsibleGaming.forEach((responsibleGaming) => {
        responsibleGaming.nameFooter = translateName[responsibleGaming.path];
      });
    },
    // Call list Client Agents inside betCard's combobox
    getServerTime() {
      this.$axios
        .post("/main/serverTime")
        .then((response) => {
          if (response.status === 200) {
            // Armazena a hora do servidor
            let serverTime = new Date(response.data.dados).getTime();
            // Armazena a hora atual
            let localTime = +Date.now();
            // Calcula a diferença que será aplicada entre a hora atual e a hora do servidor
            let timeDiff = serverTime - localTime;
            setInterval(() => {
              let server = +Date.now() + timeDiff;
              // Concise way to format time according to system locale.
              // In my case this returns "3:48:00 am"
              this.time = Intl.DateTimeFormat(navigator.language, {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
              }).format(server);
            }, 1000);
          }
        })
        .catch((err) => {
          if (err.response.data.status === 400) {
            return;
          }
        });
    },
    getItemUrl(item) {
      if (this.$domain() === "betpremier") {
        if (item.icon === "mdi-whatsapp") {
          return `https://api.whatsapp.com/send?phone=5551997370145&text=Ol%C3%A1,%20vim%20atrav%C3%A9s%20do%20site%20e%20preciso%20de%20suporte`;
        }
      }

      return item.url;
    },
  },
};
</script>
